<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-form class="mt-5">
      <template v-for="rowItem in row.items">
        <v-text-field
          v-if="!isRelatedField(rowItem)"
          v-bind:label="getFieldLabel(rowItem.column)"
          v-model="rowItem.value"
          :key="rowItem.column.name"
        ></v-text-field>
        <RelatedTableField
          v-if="isRelatedField(rowItem)"
          :key="rowItem.column.name"
          :label="getFieldLabel(rowItem.column)"
          :value.sync="rowItem.value"
          :internalTableId="rowItem.column.relatedTableId"
        />
      </template>
    </v-form>
    <template slot="footer">
      <span class="red--text">{{ messageError }}</span>
    </template>
  </base-modal>
</template>
<script>
import InternalTableService from '@/services/InternalTableService';
import InternalTableRow from '@/ecm/models/internalTable/InternalTableRow';
import InternalTableRowItem from '@/ecm/models/internalTable/InternalTableRowItem';
import RelatedTableField from '@/components/document/documentModal/internalTable/RelatedTableField';

export default {
    components: {
        RelatedTableField,
    },
    data() {
        return {
            modal: {
                title: this.$t('InsertData'),
                key: 'internalTableDataModal',
            },
            open: false,
            defFieldId: null,
            row: new InternalTableRow(),
            messageError: '',
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
    },
    methods: {
        isRelatedField(rowItem) {
            return rowItem.column.relatedTableId != 0;
        },
        getFieldLabel(column) {
            return column.isRequired ? column.name + '*' : column.name;
        },
        saveItem() {
            var hasError = false;
            this.row.items.forEach((item) => {
                if (item.column.isRequired && !item.value) {
                    this.messageError = `${this.$t('RequiredField')}: ${
                        item.column.name
                    }`;
                    hasError = true;
                }
            });

            if (hasError) {
                return;
            }

            this.messageError = '';
            this.modalInstance.progress(true);

            InternalTableService.addData(this.defFieldId, [this.row.toDto()])
                .then((result) => {
                    if (result) {
                        this.$emit('on-item-saved');
                    }
                })
                .catch((error) => {
                    this.messageError = error.response.data.message || error.message;
                })
                .then(() => {
                    //always
                    this.modalInstance.progress(false);
                });
        },
        showModal(defFieldId, internalTableId) {
            this.defFieldId = defFieldId;
            InternalTableService.get(internalTableId).then((data) => {
                this.row.items = data.Columns.map(
                    (column) => new InternalTableRowItem(column)
                );
                this.open = true;
            });
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>
